import * as Yup from 'yup'

const validationSchema = Yup.object().shape({
    nombre: Yup.string().required('El nombre es obligatorio'),
    clave: Yup.string().required('La clave del grupo es obligatoria.'),
    direccion: Yup.string(),
})

export default validationSchema